<template>
    <div>
        <div class="labelCorrection-top">
            <label-correction-search ref="search"></label-correction-search>
        </div>
        <table-label-correction></table-label-correction>
    </div>
</template>

<script>
    import TableLabelCorrection from "./TableLabelCorrection";
    import LabelCorrectionSearch from "./LabelCorrectionSearch";

    export default {
        name: 'LabelCorrection',
        components: {
            LabelCorrectionSearch,
            TableLabelCorrection
        }
    }
</script>

<style scoped>
    .labelCorrection-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .labelCorrection-title > div:nth-child(1) {
      float: left;
    }

    .labelCorrection-title > div:nth-child(2) {
      float: right;
      margin-top: -6px;
    }
    .labelCorrection-top {
      width: 100%;
      height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/label_management/tag_management/label_correction/LabelCorrection.vue